var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGruppeInform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(10 18)",
    style: {
      fontSize: 16,
      fontFamily: "Swiss721BT-BoldCondensed,Swis721 Cn BT",
      fontWeight: 700,
      letterSpacing: ".05em",
      fill: "#00c4ff"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 347",
    d: "M12 0a12 12 0 1 0 12 12A11.987 11.987 0 0 0 12 0zm0 22.5A10.5 10.5 0 1 1 22.5 12 10.629 10.629 0 0 1 12 22.5z",
    style: {
      fill: "#00c4ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGruppeInform);
export default __webpack_public_path__ + "static/media/gruppe-inform.636fed7e4e11114cc16f3fd59dbbc326.svg";
export { ForwardRef as ReactComponent };